import { translate } from "./common/utilities";

export class TranslatorConverter {
    booleanToYesNoConverter(b: boolean): string {
        return b ? 'بله' : 'خیر';
    }
    genderConverter(isMale: boolean): string {
        return isMale ? translate("TranslatorConverter.male", {}) : translate("TranslatorConverter.female", {});
    }
    boleanYesAndNoConverter(isTrue: boolean): string {
        return isTrue ? "بله" : "خیر";
    }
    opcStatusConverter(isDisable: boolean): string {
        return isDisable ? "غیرفعال" : "فعال";
    }
    personnelStatusConverter(isDisable: boolean): string {
        return isDisable ? "غیر فعال" : "فعال";
    }
    public translateInternalTransferType(v: number) {
        switch (v) {
            case 10: return translate("TranslatorConverter.warehouseTransfer", {});
            case 11: return translate("TranslatorConverter.codeTransfer", {})
            default: return translate("TranslatorConverter.unknown", {});
        }
    }

    public opTypeNameConverter(typeNumber: number): string {
        switch (typeNumber) {
            case 1: return "عملیات";
            case 2: return "انبارش";
            case 3: return "بازرسی";
            case 4: return "عملیات و بازرسی";
            case 5: return "انبار و بازرسی";
            default: return "";
        }
    }
    public requestBillTypeNameConverter(billType: number): string {
        switch (billType) {
            case 1: return translate("TranslatorConverter.receipt", {});
            case 2: return translate("TranslatorConverter.remittance", {});
            case 3: return translate("TranslatorConverter.reservationReceipt", {});
            case 4: return translate("TranslatorConverter.reservationRemittance", {});
            default: return "";
        }
    }

    payableReceivableConverter(v: number) {
        switch (v) {
            case 1: return translate("TranslatorConverter.payment", {});
            case 2: return translate("TranslatorConverter.receive", {});
            default: return '';
        }
    }
    methodConverter(v: number) {
        switch (v) {
            case 1: return translate("TranslatorConverter.sale", {});
            case 2: return translate("TranslatorConverter.returned", {});
            case 3: return translate("TranslatorConverter.buy", {});
            case 4: return translate("TranslatorConverter.purchaseReturn", {});
            case 5: return translate("TranslatorConverter.pose", {});
            case 6: return translate("TranslatorConverter.cardTransfer", {});
            case 7: return translate("TranslatorConverter.invoiceCancel", {});
            case 8: return translate("TranslatorConverter.Iban", {});
            case 9: return translate("TranslatorConverter.cash", {});
            case 10: return translate("TranslatorConverter.transfer", {});
            case 12: return translate("TranslatorConverter.cheque", {});
            case 13: return translate("TranslatorConverter.loan", {});
            default: return '';
        }
    }
    arapTransactionStatusConverter(v: number) {
        switch (v) {
            case 1: return translate("TranslatorConverter.awaitingConfirmation", {});
            case 2: return translate("TranslatorConverter.confirmed", {});
            case 3: return translate("TranslatorConverter.failed", {});
            default: return '';
        }
    }
    public paymentProcessStateNameConverter(v: number): string {
        switch (v) {
            case 1: return translate("TranslatorConverter.awaitingOrder", {});
            case 2: return translate("TranslatorConverter.awaitingPermission", {});
            case 3: return translate("TranslatorConverter.permission", {});
            case 4: return translate("TranslatorConverter.paid", {});
            default: return '';
        }
    }
    public paymentProcessTypeNameConverter(v: number): string {
        switch (v) {
            case 1: return translate("TranslatorConverter.prepayment", {});
            case 2: return translate("TranslatorConverter.onAccount", {});
            case 3: return translate("TranslatorConverter.checkout", {});
            default: return '';
        }
    }
    public transactionTransferTypeNameConverter(v: number): string {
        switch (v) {
            case 1: return translate("TranslatorConverter.cash", {});
            case 2: return translate("TranslatorConverter.pose", {});
            case 3: return translate("TranslatorConverter.cardTransfer", {});
            case 4: return translate("TranslatorConverter.transfer", {});
            case 5: return translate("TranslatorConverter.cheque", {});
            case 6: return translate("TranslatorConverter.withdraw", {});
            case 7: return translate("TranslatorConverter.online", {});
            case 8: return translate("TranslatorConverter.Iban", {});
            default: return '';
        }
    }
    public translateAccountType(v: number) {
        switch (v) {
            case 1: return translate("TranslatorConverter.currentAccount", {});
            case 2: return translate("TranslatorConverter.saving", {});
            case 3: return translate("TranslatorConverter.interestFreeLoan", {});
            default: return translate("TranslatorConverter.unknown", {});
        }
    }
    public productTypeConvertor(typeNumber: number) {
        switch (typeNumber) {
            case 1: return "محصول نهایی";;
            case 2: return "مواد اولیه";
            case 3: return "کالای نیمه ساخته";
            default: return 'سایر';
        }
    }
}